import stringSimilarity  from 'string-similarity';

export const similarity  = (str1,str2) => Math.round(stringSimilarity.compareTwoStrings(str1,str2)*100);  